import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { deleteNewsServer, newsServer } from "../../../apis/newsApi";
import { Table } from "antd";
import { useShepherdTour } from "react-shepherd";
import steps from "../../../const/tour/news";
import getNewsColumns from "../../../const/columns/newsColumns";

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  // for page tour
  const tourOptions = {
    defaultStepOptions: {
      cancelIcon: {
        enabled: true,
      },
    },
    useModalOverlay: false,
  };
  const tour = useShepherdTour({ tourOptions, steps });

  useEffect(() => {
    fetchNews();
    return () => {
      console.log("cancel app");
      console.log(tour);
      // inpRef.current?.click()
      tour.cancel();
    };
  }, []);

  const fetchNews = async () => {
    try {
      const res = await newsServer({ pageNo: 1 });
      setNews(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const deleteNews = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this News?"
    );
    if (isConfirmed) {
      await deleteNewsServer(id);
      setLoading(true);
      fetchNews();
    }
  };
  const columns = getNewsColumns(deleteNews);
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              <Link
                to="/news_action"
                onClick={tour.cancel}
                className="btn add-new btn-primary mb-3"
              >
                Add News
              </Link>
              <a className="btn-ghost" onClick={tour.start}>
                Start Tour
              </a>
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={news?.length > 0 ? news : []}
                  className="table-striped "
                  rowKey={(record) => record.id}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default News;
